import Header from "../common/Header";
import Footer from "../common/Footer";
import styles from "./PrivacyPolicy.module.css";

const PrivacyPolicy = () => {
  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.headerSection}>
        <h1 className={styles.mainTitle}>Privacy Policy</h1>
      </div>

      <div className={`${styles.mainWrapper} ${styles.privacyContent}`}>
        <span className={styles.emptySpan}></span>

        <div className={styles.contentWrapper}>
          <span className={styles.smallSpan}></span>

          <div>
            <p>
              <strong>
                It's important to us that you can feel confident that any
                personal data that we hold on you or your employees is safe and
                being looked after. We appreciate the trust you place in us and
                in return we respect our customers' privacy and are committed to
                protecting your personal information.
              </strong>
            </p>

            <p>
              ENGIE operates the{" "}
              <a
                href="https://www.engie.co.uk/"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.engie.co.uk
              </a>{" "}
              website. This Policy provides you with details regarding the
              collection, use and disclosure of personal data when you use our
              website and associated services with the data collected.
            </p>

            <p>
              For the purposes of information on the Data Controller the website
              is owned and operated by ENGIE Power Limited.
            </p>

            <p>Our other services Data Controllers are:</p>

            <table border="0" className={styles.table}>
              <thead>
                <tr>
                  <th width="198" align="left">
                    <strong>Our Services</strong>
                  </th>
                  <th width="403" align="left">
                    <strong>Data Controller</strong>
                  </th>
                </tr>
              </thead>
              <tbody className={styles.tableBody}>
                <tr>
                  <td width="198" align="left">
                    Electricity Supply
                  </td>

                  <td width="403" align="left">
                    ENGIE Power Limited
                  </td>
                </tr>

                <tr>
                  <td width="198" align="left">
                    Gas Supply
                  </td>

                  <td width="403" align="left">
                    ENGIE Power Limited
                  </td>
                </tr>
              </tbody>
            </table>

            <h4>
              <strong>What personal information do we hold?</strong>
            </h4>

            <p>Personal Information may include,</p>

            <ul>
              <li>
                your name and contact details including your contact number and
                email address
              </li>

              <li>the organisation or business you may represent</li>

              <li>any additional information you may have provided to us</li>

              <li>
                cookies and usage data – see our{" "}
                <a
                  href="https://www.engie.co.uk/personal-data-and-cookies-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <strong>cookies policy</strong>
                </a>
              </li>
            </ul>

            <h4>
              <strong>Why do we need your personal data?</strong>
            </h4>

            <p>We may need to collect and use your personal data to:</p>

            <ul>
              <li>respond to your enquiries and requests for assistance</li>

              <li>
                provide you with the products and services you have requested
                from us
              </li>

              <li>
                provide your company with individualised products and services
              </li>

              <li>
                track your journey across ENGIE group website in order for us to
                improve our services
              </li>

              <li>for statistical and analytical purposes</li>

              <li>
                and may pass your data to other parts of the business to respond
                on
              </li>

              <li>
                comply with our legal, contractual and industry obligations or
                processes.
              </li>
            </ul>

            <h4>
              <strong>When we might need to share your information</strong>
            </h4>

            <p>
              Personal data provided will be seen by relevant ENGIE employees.
              In certain circumstances we may share your personal information
              with third parties, this includes:
            </p>

            <ul>
              <li>
                our web service provider AlterWay Hosting, web agency Creode and
                Gentrack Data Hosting;
              </li>

              <li>
                our legal representatives or other concerned parties in
                circumstances where we reasonably believe that disclosing your
                personal information is necessary to help identify, contact or
                bring legal action against anyone damaging, injuring, or
                interfering with our rights or property, users or anyone else
                who could be harmed by such activities; and
              </li>
            </ul>

            <ul>
              <li>
                where we are otherwise authorised or required by law to do so.
              </li>
            </ul>

            <h4>
              <strong>Automated Decision Making</strong>
            </h4>

            <p>We undertake very limited automated decision making.</p>

            <p>
              If you become an energy supply customer and are in contract with
              us or owe us a debt, in accordance with the terms of our contract
              with you, we are entitled to object to another supplier
              registering your energy supply. We use an automated system to
              check your details and to object if necessary or allow the other
              supplier to register your supply. We do use manual decisions in
              some instances, and you can ask us to undertake a manual decision
              by contacting our Customer Services Team on{" "}
              <a
                href="mailto:support.customerservice.uk@engie.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                support.customerservice.uk@engie.com
              </a>
            </p>

            <h4>
              <strong>How long do we keep this information?</strong>
            </h4>

            <p>
              We'll only store your personal data for as long as is necessary to
              fulfil the purposes outlined in this Privacy Policy or for as long
              as we reasonably consider necessary to establish, exercise or
              defend our legal rights.
            </p>

            <p>
              Where our retention periods are not governed by legislation we
              will hold your personal data for one year (unless there is a
              lawful basis to retain your personal data for a longer period);
              our Retention Policy is based on commercial justifications. These
              include:
            </p>

            <ul>
              <li>to allow us to resolve any disputes or complaints</li>

              <li>
                to enable us to provide you with our products and services
              </li>
            </ul>

            <h4>
              <strong>Where is my personal data stored?</strong>
            </h4>

            <p>
              Your information and personal data will be stored in the UK, EEA
              or a country deemed to have an equivalent level of protection.
            </p>

            <p>
              ENGIE will take all steps reasonably necessary to ensure that your
              data is treated securely and in accordance with this Privacy
              Policy. Moreover, your personal data will not be transferred to an
              organisation or a country unless there are adequate controls in
              place including the security of your data and other personal
              information.
            </p>

            <h4>
              <strong>How do we safeguard your personal information?</strong>
            </h4>

            <p>
              We strive to ensure the security, integrity and privacy of the
              personal information we collect. We do our very best to ensure the
              security of personal data held by us to protect your information
              from unauthorised access, use, modification, destruction or
              disclosure.
            </p>

            <p>
              Access to personal data is restricted to authorised employees,
              contractors, agents and service providers, who are obliged to
              respect the confidentiality of any personal information held by
              us. We regularly review and update our security measures
              considering current technologies.
            </p>

            <h4>
              <strong>
                How can you access or correct your personal information, or make
                a privacy or Data Protection complaint?
              </strong>
            </h4>

            <p>
              You have the right to request access to, correction of, erasure
              of, limitation of or the portability of personal information we
              hold about you. Where the processing is based on consent, you may
              withdraw your consent to further processing at any time.
            </p>

            <p>
              You also have the right to make a complaint if you believe that we
              have not complied with privacy laws in relation to your
              information.
            </p>

            <p>
              To obtain access, correct your information, request an erasure,
              make a complaint or enquire about your rights, please contact us
              in writing using the contact details below. We will acknowledge
              any communication made in writing as soon as we can and will
              respond to any queries or complaints within one month
            </p>

            <h4>
              <strong>For personal data enquiries:</strong>
            </h4>

            <p>Attention: Data Protection Officer</p>

            <p>
              Email:{" "}
              <a
                href="mailto:dataprivacy.uk@engie.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                dataprivacy.uk@engie.com
              </a>
            </p>

            <p>Address:</p>

            <p>ENGIE Power Limited</p>

            <p>No. 1 Leeds</p>

            <p>26 Whitehall Road</p>

            <p>Leeds</p>

            <p>LS12 1BE</p>

            <p>UK</p>

            <p>
              If you are not satisfied with the response which you receive, you
              may contact the Information Commissioner's Office to make a
              complaint.
            </p>

            <p> </p>

            <p>Version Control: 01/07/24</p>
          </div>

          <span className={styles.smallSpan}></span>
        </div>

        <span className={styles.emptySpan}></span>
      </div>

      <Footer showAccordions={false} />
    </div>
  );
};

export default PrivacyPolicy;
